import Partners from "./Partners";
import Partner from './Partner'

export default Partners;

export {
  Partner
}
